export default {
  province_list: {
    110000: "黄金",
    120000: "铂金",
    130000: "钯金",
    140000: "白银"
  }
};
